

import { createTypes, async, asyncActionCreator } from 'redux-action-creator';

import { type Action } from '../../types';
import type { ThunkAction } from '../../types';

import { getBrandingImage } from '../../../service/brandingImageService';

export const types: { [key: string]: string } = createTypes(
  [...async('LOAD')],
  'BRANDING_IMAGES',
);

export const getBrandingImageUrl: () => ThunkAction = asyncActionCreator(
  types.LOAD,
  { action: () => getBrandingImage() },
);

export const receiveBrandingImage = (
  brandingImageUrl: string,
): Action<Object> => {
  return {
    type: types.LOAD_SUCCESS,
    response: { brandingImageUrl },
  };
};
